import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {handleDateChange} from '@pluto/utils';
import Select from 'react-select';
import {
    KeyboardDateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {
    array,
    object,
    func,
    string,
} from 'prop-types';

export const getDateTimePickerValue = (value: Date | null) => value || null;
export default function PollingTypeDateSelector(props: any) {
    const {
        isValidDate,
        feedsLimitField,
        pollingIntervalValueField,
        pollingTypeDateOptions,
        onChangeFeedsLimitField,
        dateValue,
    } = props;

    const handleChange = handleDateChange(pollingIntervalValueField, isValidDate);

    return (
        <div className="polling-type__date-selector-wrapper">
            <div className="polling-type__date-label">
                at
            </div>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDateTimePicker
                    ampm={false}
                    className="polling-type__date-selector"
                    autoOk
                    inputVariant="outlined"
                    variant="inline"
                    format="MM-dd-yyyy HH:mm"
                    margin="normal"
                    placeholder="MM-dd-yyyy HH:mm"
                    value={getDateTimePickerValue(dateValue)}
                    onChange={handleChange}
                />
            </MuiPickersUtilsProvider>
            <div className="polling-type__items-select-label">
                Limit
            </div>
            <Select
                className="polling-type__single-select select-overwrite"
                onChange={onChangeFeedsLimitField}
                value={[{
                    value: feedsLimitField.input.value,
                    label: feedsLimitField.input.value,
                }] as any}
                variant="outlined"
                options={pollingTypeDateOptions}
            />
        </div>
    );
}

PollingTypeDateSelector.propTypes = {
    feedsLimitField: object.isRequired,
    pollingIntervalValueField: object.isRequired,
    pollingTypeDateOptions: array.isRequired,
    onChangeFeedsLimitField: func.isRequired,
    dateValue: string.isRequired,
    isValidDate: object.isRequired,
};
